<template>
    <div class="password-strength">
        <div>{{ $t('PASSWORD_SHOULD_CONTAIN') }}:</div>
        <div
            :class="rule.req_met ? '-met' : '-not-met'"
            class="flex-row password-rule"
            v-for="rule in passwordRules"
            :key="rule.display"
        >
            <i class="material-icons">{{ rule.req_met ? 'check' : 'close' }}</i>
            <div v-text="$t(rule.display)" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        password: {
            type: String,
            default: ''
        }
    },
    computed: {
        passwordRules() {
            return [
                {
                    display: 'PASSWORD_8_CHARACTERS',
                    req_met: this.password.length > 7
                },
                {
                    display: 'PASSWORD_1_CAPITAL_LETTER',
                    req_met: /[A-Z]/.test(this.password)
                },
                {
                    display: 'PASSWORD_1_DIGIT',
                    req_met: /[0-9]/.test(this.password)
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.password-strength {
    color: $input;
    font-family: $input-family;
    box-shadow: $minimal-shadow;
    @include container;
    padding: 0.5rem !important;
    font-size: 0.7rem;
}
.password-rule {
    margin-top: 0.25rem;
    i {
        margin-right: 0.25rem;
        font-size: 1rem;
    }
    &.-met {
        i {
            color: $accent-apple;
        }
    }
    &.-not-met {
        color: $accent-red;
    }
}
</style>
